import Keycloak from 'keycloak-js';

export async function initKeycloak() {
  const keycloak = new Keycloak({
    url: process.env.KEYCLOAK_URL,
    clientId: process.env.KEYCLOAK_CLIENT,
    realm: 'B2B',
  });

  await keycloak.init({
    onLoad: 'login-required',
    checkLoginIframe: false,
  });

  localStorage.setItem('token', keycloak.token);

  function onRequestLogout() {
    localStorage.removeItem('token');
    keycloak.logout();
  }

  function onRefreshedToken(refreshed) {
    if (refreshed) {
      localStorage.setItem('token', keycloak.token);
    }
  }

  document.addEventListener('logout', onRequestLogout);

  keycloak.onTokenExpired = function onTokenExpired() {
    keycloak.updateToken(5).then(onRefreshedToken).catch(onRequestLogout);
  };
  document.addEventListener('refresh-token', () => keycloak.onTokenExpired());
  global.keycloak = keycloak;
  console.info('keycloak initialized v1.0.0');
  return keycloak;
}
